import { ResourcesConfig } from '@aws-amplify/core'
import { parseTweddleDomain } from 'lib/domain/parseTweddleDomain'

const USER_POOL_ID = import.meta.env.VITE_USER_POOL_ID
const USER_POOL_WEB_CLIENT_ID = import.meta.env.VITE_USER_POOL_WEB_CLIENT_ID
const VITE_COGNITO_REGION = import.meta.env.VITE_COGNITO_REGION
const VITE_COGNITO_DOMAIN = import.meta.env.VITE_COGNITO_DOMAIN

const _parsed = parseTweddleDomain(window.location.hostname)

// On branded domains, use the single fixed callback origin already registered in Cognito.
// On localhost / old-format URLs, fall back to the current origin (existing behaviour).
// Exported for unit testing (env vars are inlined at transform time and cannot be
// overridden via vi.stubEnv, so callers inject the values explicitly in tests).
export function deriveCallbackOrigin(
  parsed: ReturnType<typeof parseTweddleDomain>,
  envCallbackOrigin: string | undefined,
  currentOrigin: string
): string {
  // Strip any trailing slash from the env var so redirectSignIn URLs
  // never end up with a double slash (e.g. 'http://host//auth/callback').
  const normalised = envCallbackOrigin?.replace(/\/$/, '')
  return parsed && normalised ? normalised : currentOrigin
}

const _callbackOrigin = deriveCallbackOrigin(
  _parsed,
  import.meta.env.VITE_AUTH_CALLBACK_ORIGIN,
  window.location.origin
)

// Exported so use-amplify.ts can detect cross-origin flows without re-deriving the value.
export const callbackOrigin = _callbackOrigin

export const amplifyConfig: ResourcesConfig = {
  Auth: {
    Cognito: {
      userPoolId: USER_POOL_ID,
      userPoolClientId: USER_POOL_WEB_CLIENT_ID,
      loginWith: {
        oauth: {
          domain: `${VITE_COGNITO_DOMAIN}.auth.${VITE_COGNITO_REGION}.amazoncognito.com`,
          scopes: ['openid', 'profile', 'email'],
          redirectSignIn: [`${_callbackOrigin}/auth/callback`],
          redirectSignOut: [`${_callbackOrigin}/`],
          responseType: 'code',
        },
      },
    },
  },
}
